export default __webpack_public_path__ + "media/images/logo_pc-0f5728901afbf705d2163496405b66a5.png";